import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  resetAuthState,
} from "@/store/slices/auth.slice";
import { OTPVerification } from "@/components/auth/OTPVerification";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { whitelabelConfig } from "@/config/whitelabel";

export default function VerifyOTPPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    phoneNumber,
    isLoading,
    error,
    isVerified,
    authenticationId,
    isOTPSent,
  } = useAppSelector((state) => state.auth);

  const {
    statusLoading,
    isAuthenticated,
    verifyOtp,
    resendOtp,
  } = useAuth("verify-otp");

  // Handle expired/invalid session: if OTP was verified but cookie is not valid
  useEffect(() => {
    if (statusLoading) {
      return;
    }

    if (!isAuthenticated && isVerified) {
      dispatch(resetAuthState());
      navigate("/auth/login");
    }
  }, [statusLoading, isVerified, isAuthenticated, dispatch, navigate]);

  // Check if we have required auth state for active OTP flow
  useEffect(() => {
    if (isVerified) {
      return;
    }

    if (
      !isAuthenticated &&
      !isLoading &&
      (!authenticationId || !phoneNumber || !isOTPSent)
    ) {
      dispatch(resetAuthState());
      navigate("/auth/login");
    }
  }, [
    isAuthenticated,
    authenticationId,
    phoneNumber,
    isOTPSent,
    isVerified,
    isLoading,
    dispatch,
    navigate,
  ]);

  const handleVerifyOTP = (otp: string) => {
    verifyOtp(otp);
  };

  const handleResendOTP = () => {
    resendOtp();
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <img
          src={whitelabelConfig.logos.auth}
          alt={`${whitelabelConfig.brandName} logo`}
          width={90}
          height={90}
        />
      </div>

      <OTPVerification
        phoneNumber={phoneNumber || ""}
        onVerify={handleVerifyOTP}
        onResend={handleResendOTP}
        isLoading={isLoading}
        error={error || undefined}
      />
    </div>
  );
}
